import { ListOutput } from '@allocab/allocab-commons-shared-types';
import { DocumentItemOutput } from '@allocab/allocab-driver-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryClient } from '../services/datastore/react-query';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchAccountDocuments = () => driverApi.get<void, DocumentItemOutput, 'list'>(`/v1/document/account`);

export const useFetchAccountDocuments = (
  options: QueryOptions<typeof queryKeys.user.fetchAccountDocuments, ListOutput<DocumentItemOutput>> = {},
) => useQuery(queryKeys.user.fetchAccountDocuments(), fetchAccountDocuments, { ...options });

export const prefetchAccountDocuments = () =>
  queryClient.prefetchQuery(queryKeys.user.fetchAccountDocuments(), fetchAccountDocuments, {
    staleTime: DEFAULT_CACHE_TIME,
  });
